module.exports = __webpack_public_path__ + "static/media/login.e680d4ca.svg";